export const en = {
    add_bonus_card: 'Add bonus card',
    empty_description: 'To receive bonuses even on a business trip',
    empty_title: 'Add a loyalty card',
};
